module.exports = __webpack_public_path__ + "static/media/Booklet-GeneticTesting.de9fee86.pdf";